"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimecardRequestCorrection = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Theme_1 = require("@amzn/atoz-web/Theme");
const Button_1 = require("@amzn/atoz-web/Button");
const Card_1 = require("@amzn/atoz-web/Card");
const Row_1 = require("@amzn/atoz-web/Row");
const Text_1 = require("@amzn/atoz-web/Text");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const logger_1 = require("../../logger");
const utils_1 = require("./utils");
const Popover_1 = require("@amzn/atoz-web/Popover");
const Flex_1 = require("@amzn/atoz-web/Flex");
const TimecardRequestCorrection = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { clientName } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.REQUEST_CORR_IN_TIMECARD.COUNT
        },
        isComponentLoaded: true
    });
    const requestCorrLinks = (0, utils_1.getRequestCorrLinks)(props, 'web');
    const onLinkClick = (url, metricName) => {
        location.assign(url);
        logger_1.logger.emitCountMetric({
            metricName,
            dimensions
        });
    };
    const isEmptyLink = requestCorrLinks.every((link) => !link.eligible);
    const renderListOfButtons = (buttonLinksList) => {
        return (react_1.default.createElement(react_1.default.Fragment, null, buttonLinksList.map((link) => link.eligible && (react_1.default.createElement(Button_1.Button, { key: link.label, variant: Button_1.ButtonVariant.Secondary, "aria-label": t(link.label), onClick: () => onLinkClick(link.redirectUrl, link.metricName) }, t(link.label))))));
    };
    const renderClickableTextList = (clickableLinksList) => {
        return (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gridGap: 'S200', border: '1' }, clickableLinksList.map((link) => link.eligible && (react_1.default.createElement(Button_1.Button, { key: link.label, color: 'primary70', variant: Button_1.ButtonVariant.Tertiary, "aria-label": t(link.label), onClick: () => onLinkClick(link.redirectUrl, link.metricName) }, t(link.label))))));
    };
    return (!isEmptyLink && (react_1.default.createElement(StyledCard, { dataTestId: utils_1.requestCorrContainerTestId, flexDirection: "column" },
        react_1.default.createElement(Text_1.Text, { fontSize: "T200", fontWeight: "bold", margin: { top: 0, bottom: 'S300' } }, t('time_and_attendance_Timecard_Request_Correction_Title')),
        (requestCorrLinks === null || requestCorrLinks === void 0 ? void 0 : requestCorrLinks.length) > 4 ? (react_1.default.createElement(Row_1.Row, { flexWrap: "wrap", gridGap: "S200" },
            renderListOfButtons(requestCorrLinks.slice(0, 3)),
            react_1.default.createElement(Popover_1.Popover, { triggerText: t('time_card_more_action_button_label'), position: Popover_1.PopoverPosition.BottomTrailing }, () => renderClickableTextList(requestCorrLinks.slice(3))))) : (react_1.default.createElement(Row_1.Row, { flexWrap: "wrap", gridGap: "S200" }, renderListOfButtons(requestCorrLinks))))));
};
exports.TimecardRequestCorrection = TimecardRequestCorrection;
const StyledCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(`
   border: none;
   display: flex;
   &>div {
    flex: 1;
   }
`);
